<template>
  <div class="login-container">
    <LogoIcon />
    <span class="title">Awesome. What’s your name?</span>
    <div class="login-content">
      <div class="inputs">
        <div class="floating-label">
          <input
            v-model="firstname"
            placeholder="First name"
            type="text"
            name="firstname"
            id="firstname"
            autocomplete="off"
          />
          <label for="firstname">First name</label>
        </div>
        <div class="floating-label">
          <input
            v-model="lastname"
            placeholder="Last name"
            type="text"
            name="lastname"
            id="lastname"
            autocomplete="off"
          />
          <label for="lastname">Last Name</label>
        </div>
      </div>
      <button
        @click="next()"
        class="button-default big continue"
        :disabled="!lastname || !firstname || isLoading"
      >
        <span>Continue</span>
      </button>
    </div>
  </div>
</template>
<script>
import LogoIcon from "@/components/LogoTile";
import { M_UPDATE_NAME, M_UPDATE_SIGNUP_STEP } from "@/graphql";
import { mapState } from "vuex";
export default {
  name: "SignupWizardStepSetName",
  components: {
    LogoIcon
  },
  data() {
    return {
      firstname: null,
      lastname: null,
      isLoading: false
    };
  },
  computed: {
    ...mapState("signup", ["id"])
  },
  async created() {
    this.$apollo_wsClient.close();
    this.$store.commit("signup/resetArtists");
    await this.setStep(4);
  },
  methods: {
    async setStep(step) {
      console.log("setStep", step, this.id);
      try {
        const result = await this.$apollo.mutate({
          client: "localClient",
          mutation: M_UPDATE_SIGNUP_STEP,
          variables: {
            id: this.id,
            signup_step: step
          }
        });
        console.log("setStep", result);
      } catch (e) {
        console.log(e);
      }
    },
    async setName() {
      return await this.$apollo.mutate({
        // client: "localClient",
        mutation: M_UPDATE_NAME,
        variables: {
          id: this.id,
          first_name: this.firstname,
          last_name: this.lastname
        }
      });
    },
    async next() {
      try {
        this.isLoading = true;
        const result = await this.setName();
        console.log(result);
        this.$store.commit("signup/setData", {
          firstname: this.firstname,
          lastname: this.lastname
        });
        this.$emit("nextStep");
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  width: 100vw;
  height: 100%;
  /* BG/type2 */
  background: $bg-type-2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .logo-icon {
    width: 54px;
  }
  .title {
    display: block;
    margin-top: 30px;
    font-weight: bold;
    font-size: 30px;
    line-height: 42px;
    /* White */
    color: #ffffff;
    mix-blend-mode: normal;
    opacity: 0.9;
  }
  .login-content {
    //width: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 12px;
    margin-top: 30px;
    .inputs {
      display: grid;
      grid-template-columns: repeat(2, 220px);
      grid-gap: 20px;
    }
    button.continue {
      margin-top: 18px;
      width: 276px;
    }
  }
}
@media (max-width: 600px) {
  .login-container {
    padding: 24px;
    .title {
      text-align: center;
    }
    .login-content {
      width: 100%;
      padding: 0;
      .inputs {
        grid-template-columns: repeat(1, 100%);
        width: 100%;
      }
      button.continue {
        width: 100%;
      }
    }
  }
}
</style>
